import React from 'react';
import './BottomNav.css';

export default function BottomNav({ current, onChange }) {
  return (
    <nav className="bottom-nav">
      <button
        className={`nav-btn ${current === 'sessions' ? 'active' : ''}`}
        onClick={() => onChange('sessions')}
      >
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1" />
          <rect x="12" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1" />
          <rect x="3" y="12" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1" />
          <rect x="12" y="12" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1" />
        </svg>
        <span>Clases</span>
      </button>

      <button
        className={`nav-btn ${current === 'profile' ? 'active' : ''}`}
        onClick={() => onChange('profile')}
      >
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <circle cx="11" cy="7" r="4" stroke="currentColor" strokeWidth="1" />
          <path d="M3 19c0-4.418 3.582-8 8-8s8 3.582 8 8" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
        </svg>
        <span>Perfil</span>
      </button>
    </nav>
  );
}
